export default "__VITE_ASSET__CJWvfdsR__"